export const AUTH_CHANGE_GROUP = "authChange";
export const LOGIN_GROUP = "login";
export const LOGOUT_GROUP = "logout";
